/* eslint-disable prefer-destructuring */
import { SyncableWappRoomFields } from '@weblite/ts-action/wapp-room'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

type WappRoomUpdatePatch = Omit<SyncableWappRoomFields, 'roomId'>

const synchronizer = eventBasedSynchronizer<WappRoomUpdatePatch, true>(
  'wappRoomSync',
  { merge: true },
)

export const set = synchronizer.set
export const getAll = synchronizer.getAll
export const getIds = synchronizer.getIds
